/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum Device {
  Unknown = 1,
  Desktop = 2,
  Tablet = 4,
  Mobile = 8,
  Watch = 16,
  Tv = 32,
  Console = 64,
  Car = 128,
  IoT = 256
}
